/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type categoriesSection_home$ref = any;
type citiesSection_home$ref = any;
type featuredSection_home$ref = any;
type featuredStorySection_home$ref = any;
type menuSection_home$ref = any;
type promotedSection_home$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type homePage_home$ref: FragmentReference;
export type homePage_home = {|
  +headerTitle: string,
  +headerSubtitle: string,
  +headerPicture: ?string,
  +headerArticle: {|
    +slug: ?string,
    +picture: ?string,
    +city: ?{|
      +slug: string,
      +color: ?string,
    |},
  |},
  +highlights: ?{|
    +nomination: ?$ReadOnlyArray<?{|
      +card_image: ?string,
      +link: ?string,
      +text: ?string,
      +color: ?string,
    |}>
  |},
  +seo: ?{|
    +title: ?string,
    +description: ?string,
  |},
  +social: ?{|
    +twitter: ?$ReadOnlyArray<?{|
      +type: ?string,
      +title: ?string,
      +image: ?string,
      +handle: ?string,
      +description: ?string,
    |}>,
    +generic: ?$ReadOnlyArray<?{|
      +title: ?string,
      +image: ?string,
      +description: ?string,
    |}>,
  |},
  +$fragmentRefs: featuredSection_home$ref & promotedSection_home$ref & citiesSection_home$ref & featuredStorySection_home$ref & categoriesSection_home$ref & menuSection_home$ref,
  +$refType: homePage_home$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "color",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "image",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "homePage_home",
  "type": "Home",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "headerTitle",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "headerSubtitle",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "headerPicture",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "headerArticle",
      "storageKey": null,
      "args": null,
      "concreteType": "Article",
      "plural": false,
      "selections": [
        v0,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "picture",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "city",
          "storageKey": null,
          "args": null,
          "concreteType": "City",
          "plural": false,
          "selections": [
            v0,
            v1
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "highlights",
      "storageKey": null,
      "args": null,
      "concreteType": "Highlights",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "nomination",
          "storageKey": null,
          "args": null,
          "concreteType": "Nominations",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "card_image",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "link",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "text",
              "args": null,
              "storageKey": null
            },
            v1
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seo",
      "storageKey": null,
      "args": null,
      "concreteType": "SEO",
      "plural": false,
      "selections": [
        v2,
        v3
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "social",
      "storageKey": null,
      "args": null,
      "concreteType": "SocialMedia",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "twitter",
          "storageKey": null,
          "args": null,
          "concreteType": "TwtrSlices",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "type",
              "args": null,
              "storageKey": null
            },
            v2,
            v4,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "handle",
              "args": null,
              "storageKey": null
            },
            v3
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "generic",
          "storageKey": null,
          "args": null,
          "concreteType": "GenSocialSlices",
          "plural": true,
          "selections": [
            v2,
            v4,
            v3
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "featuredSection_home",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "promotedSection_home",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "citiesSection_home",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "featuredStorySection_home",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "categoriesSection_home",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "menuSection_home",
      "args": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b0fbf55264112ec8493795049704243e';
module.exports = node;
